import { render, staticRenderFns } from "./add-qualification.vue?vue&type=template&id=22ffbff5&scoped=true&"
import script from "./add-qualification.vue?vue&type=script&lang=js&"
export * from "./add-qualification.vue?vue&type=script&lang=js&"
import style0 from "./add-qualification.vue?vue&type=style&index=0&id=22ffbff5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ffbff5",
  null
  
)

export default component.exports